export interface ImageInfo {
    _id: string;
    src: string;
    key: string;
    name: string;
    previewUrl: string;
}

interface AppIcon {
    icon: number;
    color: number;
    url: string;
}

// 模板表单字段（由模板中心后台配置的字段，相当于原来的ISolution）
export interface TemplateFormField {
    // 流量来源
    utm_src: string;
    // 封面
    cover?: ImageInfo[];
    // 截图
    screenshot?: ImageInfo[];
    // 标签，如：采购,销售,仓库
    tags?: string[];
    // 排名
    rank?: number;
    // 名称
    name: string;
    // 标记：如：官方、套件、热门
    labels?: string[];
    // 行业
    industry?: string[];
    // 常见问答
    faq?: {
        faq_question?: string;
        faq_answer?: string;
    }[];
    // 详细描述
    detail_desc?: string;
    // 简述
    brief_desc?: string;
    // 场景
    scene?: string[];
    // 作者头像（jodoo用）
    author_avatar?: string;
    // 内容语言（jodoo用，需适配新的值）
    lang?: string;
    // 应用ID
    app_id: string;
    // (结构变更) 图标，需要适配
    app_icon: AppIcon;
    // 作者昵称
    author_nickname: string;
    /** 当前模板配置的付费模式（免费、付费、未配置） */
    fee_type?: 'free' | 'paid';
}

export interface Template {
    // 空间ID
    space_id: string;
    // 表单ID
    form_id: string;
    // 数据ID
    data_id: string;
    // 资源ID
    resource_key: string;
    // 表单字段值
    value: TemplateFormField;
    // 1：上架；2：后台上架；3：已下架
    state: number;
    // 创建时间
    create_time: string;
    // 更新时间
    update_time: string;
    // 最近一次发布时间
    publish_time: string;
    // 安装量
    install_count: number;
    // 安装量（基础值）
    install_count_base: number;
    // 安装量（显示值）
    install_count_view: number;
    // 模板预览链接
    previewUrl: string;
}

export interface TemplateDetail {
    data: Template;
    similar: Template[];
}

// 模板详情页入口
export enum SolutionSource {
    GUESS = 'guess', // 猜你想要
    HOT = 'hot', // 热门模板
    MARKET = 'market', // 没有找到想要的模板？试试下面
    HELP = 'help', // 帮助入口
    NEW_GUIDE = 'newGuide', // 新手引导
    LINK = 'link' // 直接打开
}
